var map = {
	"./All mailActive.png": 7935,
	"./ArchiveActive.png": 8554,
	"./DraftsActive.png": 5260,
	"./InboxActive.png": 6222,
	"./SentActive.png": 8625,
	"./SpamActive.png": 7119,
	"./StarredActive.png": 4490,
	"./TrashActive.png": 2725
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6594;